'use strict';

var geolocationService = require('../services/geolocation');

var $modal = $('#inStoreInventoryModal');
var $form = $('.js-store-drawer');
var $advancedSearch = $('.js-store-drawer-advanced, .js-store-drawer-advanced-inventory');
var $search = $('.js-store-drawer-search');
var $searchResults = $('.js-store-drawer-results');
var $postalCodeInput = $('input[name=postalCode]');
var $inventory = $('.js-store-drawer-advanced-inventory');
var $geoLocationErrors = $('.js-geolocation-error');
var $useMyLocationButton = $('.js-drawer-detect-location');

/**
 * Sets the visibility toggle state for in-stock items based on session storage and a hidden fieldset.
 * @returns {void}
 */
function setStockVisibilityToggleState() {
    var inStockToggleStatus = window.sessionStorage.getItem('show_instock');
    var inStockInput = $('.js-show-instock-input');
    var inStockIgnoreLimit = inStockInput.closest('fieldset').hasClass('d-none');
    var checked = !inStockIgnoreLimit && inStockToggleStatus === '1';

    inStockInput.prop('checked', checked);
}

/**
 * Sets the state of the detect location button.
 * @param {boolean} isError - Indicates if the geolocation was successful.
 */
function setDetectLocationState(isError) {
    var baseClass = 'store-locator__detect-location-button';

    $useMyLocationButton.removeClass(baseClass + '--red')
    $useMyLocationButton.removeClass(baseClass + '--green');

    if (typeof isError === 'boolean') {
        if (isError) {
            $useMyLocationButton.addClass(baseClass + '--red');
        } else {
            $useMyLocationButton.addClass(baseClass + '--green');
        }
    } else {
        $useMyLocationButton.addClass(baseClass);
    }
}

/**
 * Sets the store drawer fields and values.
 * @param {Object} data - The store drawer fields and values.
 * @param {string} [data.postalCode] - The postal code.
 * @param {number} data.lat - The latitude.
 * @param {number} data.long - The longitude.
 * @param {boolean} [data.showAdvancedSearch] - Whether to show advanced search.
 * @param {boolean} [data.showInventoryLimit] - Whether to show inventory limit.
 * @param {boolean} [data.search] - Whether to perform a search.
 */
function populateStoreDrawerForm(data) {
    Object.keys(data).forEach(function (item) {
        var $input = $form.find('input[name=' + item + ']');
        if (typeof data[item] === 'boolean') {
            $input.prop('checked', data[item]);
        } else if (typeof data[item] === 'string' || $.isNumeric(data[item])) {
            $input.val(data[item]);
        }
    });
}

/**
 * Starts the spinner for search results and search input.
 * @returns {void}
 */
function spinnerStart() {
    $searchResults.children('div').first().spinner().start();
    $search.spinner().start();
}

/**
 * Stops the spinner for search results and search input.
 * @returns {void}
 */
function spinnerStop() {
    $searchResults.children('div').spinner().stop();
    $search.spinner().stop();
}

/**
 * Sets the geolocation fields based on the geolocation result.
 * @param {Object} geolocationResult - The result from the geolocation service.
 * @param {boolean} geolocationResult.error - Indicates if there was an error.
 * @param {string} [geolocationResult.errorMessage] - The error message if there was an error.
 * @param {string} [geolocationResult.locationText] - The location text to display.
 * @param {number} [geolocationResult.latitude] - The latitude.
 * @param {number} [geolocationResult.longitude] - The longitude.
 * @returns {void}
 */
function setGeolocationFields(geolocationResult) {
    $geoLocationErrors.html('').hide();
    setDetectLocationState(geolocationResult.error);

    if (geolocationResult.error) {
        $geoLocationErrors.html(geolocationResult.errorMessage).show();
    } else {
        var formData = {
            lat: geolocationResult.latitude,
            long: geolocationResult.longitude
        };
        if (geolocationResult.latitude && geolocationResult.longitude) {
            formData.postalCode = '';
        }
        populateStoreDrawerForm(formData);
    }

    if (geolocationResult.locationText) {
        $useMyLocationButton.html(geolocationResult.locationText);
    }
}

/**
 * Performs the search with the filled out store drawer fields.
 * @returns {void}
 */
function storeDrawerSearch() {
    spinnerStart();
    $.ajax({
        url: $form.attr('action'),
        method: 'GET',
        data: $form.serialize(),
        success: function (response) {
            $searchResults.empty();
            if ($('.js-global-header.is-sticky')) {
                $('.js-global-header').removeClass('is-sticky');
            }
            $searchResults.html(response.storesResultsHtml);
            if (response.geolocation.countryCode === 'CA') {
                $('.js-store-locator-ca-users').show();
            }
            if (!response.hasResults) {
                $('.js-store-no-results').show();
            }
            if (response.availabilityKnown) {
                $inventory.removeClass('d-none');
            }
        },
        error: function (err) {
            if (err.responseJSON && err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        },
        complete: function () {
            spinnerStop();
        }
    });
}

module.exports = {
    /**
     * Initializes the store drawer module.
     * @returns {void}
     */
    init: function () {
        $('body').on('store-drawer:open', async function (e, data) {
            e.preventDefault();
            $modal.modal('show');
            spinnerStart();

            populateStoreDrawerForm(data);

            if (data.showInventoryLimit) {
                $inventory.removeClass('d-none');
            } else {
                $inventory.addClass('d-none');
            }

            if (data.showAdvancedSearch) {
                $advancedSearch.removeClass('d-none');
            }

            if (data.currentStore) {
                $form.find('input[name=currentStore]').val(data.currentStore);
            }

            // Check the form to see if it has previously been filled out
            if ($postalCodeInput.val() === '' && $('input#lat').val() === '' && $('input#long').val() === ''){
                var geolocationResult = await geolocationService.getGeolocation();
                setGeolocationFields(geolocationResult);
            }

            spinnerStop();

            if (data && data.search) {
                setStockVisibilityToggleState();
                storeDrawerSearch();
            }
        });
    },
    /**
     * Binds the search event to the form submit.
     * @returns {void}
     */
    search: function () {
        $form.on('submit', function (e) {
            e.preventDefault();
            storeDrawerSearch();
        });
    },
    /**
     * Binds the searchAjax event to the body.
     * @returns {void}
     */
    searchAjax: function () {
        $('body').on('store-drawer:searchAjax', function (e) {
            e.preventDefault();
            $postalCodeInput.removeAttr('required');
            storeDrawerSearch();
            $postalCodeInput.attr('required', true);
        });
    },
    /**
     * Binds the change event to the postal code input for manual search.
     * @returns {void}
     */
    searchManual: function () {
        $postalCodeInput.off('change').on('change', function (e) {
            e.preventDefault();
            var geolocationResult = new geolocationService.GeolocationModel();
            setGeolocationFields(geolocationResult);
            setDetectLocationState();
        });
    },
    /**
     * Binds the select store event to the body.
     * @returns {void}
     */
    selectStore: function () {
        $('body').on('click', '.js-select-store-link', function (e) {
            e.preventDefault();
            spinnerStart();
            var url = $(this).attr('data-action-url');
            $.ajax({
                url: url,
                method: 'POST',
                data: $form.serialize(),
                success: function () {
                    $modal.modal('hide');
                    $('.js-store-drawer-open').trigger('focus');
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                },
                complete: function () {
                    spinnerStop();
                }
            });
        });
    },
    /**
     * Binds the change event to the in-stock input to show in-stock stores.
     * @returns {void}
     */
    showInStockStores: function () {
        $('.js-show-instock-input').on('change', function () {
            window.sessionStorage.setItem('show_instock', $(this).is(':checked') ? '1' : '0');
            $('body').trigger('store-drawer:searchAjax');
        });
    },
    /**
     * Binds the click event to the detect location button.
     * @returns {void}
     */
    detectLocation: function () {
        $('body').on('click', '.js-drawer-detect-location', async function (e) {
            e.preventDefault();
            spinnerStart();
            var geolocationResult = await geolocationService.getGeolocation();
            setGeolocationFields(geolocationResult);
            spinnerStop();

            if (!geolocationResult.error) {
                storeDrawerSearch();
            }
        });
    },
    /**
     * Returns focus to the change store link after the modal has been closed.
     * @returns {void}
     */
    close: function () {
        $('body').on('click', '.js-close-store-drawer', function () {
            $('.js-store-drawer-open').trigger('focus');
        });
    }
};
